module["exports"] = ["Nord", "Ost", "West", "Süd", "Neu", "Alt", "Bad"];